import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Report from "../Report";
import { TextField } from "@material-ui/core";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import InputSelectGame from "../InputSelectGame";
import { dateTimeReportFormatter } from "../../fomatters/DateFormatter";
import InputSelect from "../InputSelect";

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() + 1);

const startDateValue = new Date().toISOString().split("T")[0];
const endDateValue = currentDate.toISOString().split("T")[0];

const consultaMap = {
  1: "Side",
  2: "Over / Under",
  3: "$-Line",
};

const consultaProcess = (data) => {
  const left = {
    1: "Side",
    2: "Over",
    3: "$-Line",
  };

  const right = {
    1: "Side",
    2: "Under",
    3: "$-Line",
  };

  return {
    consulta: data[0].consulta,
    lPlayer: left[data[0].consulta],
    rPlayer: right[data[0].consulta],
  };
};

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function ActionHistory() {
  const [endDate, setEndDate] = useState(endDateValue);

  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback((event) => {
    setStartDate(event.target.value);

    const endDateChanged = new Date(event.target.value);
    endDateChanged.setDate(endDateChanged.getDate() + 1);
    setEndDate(endDateChanged.toISOString().split("T")[0]);
  }, []);

  const [idGame, setIdGame] = useState(0);
  const onGameChanged = useCallback((g) => setIdGame(g), []);

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="Game Date"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <InputSelectGame
          startDate={startDate}
          endDate={endDate}
          setSelectValue={onGameChanged}
        />
      </div>
      <Report
        groupBy="consultaGroup"
        title="Action History Report"
        getUrl={() => "/Reports/Report_Action_History"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          Office: office,
          IdGame: idGame,
        })}
        getPreProcess={(data) =>
          data
            .filter((item) => item.consulta > 0)
            .map((item) => ({
              ...item,
              consultaGroup: consultaMap[item.consulta],
              lRiskWin: item.lRiskAmount
                ? `${item.lRiskAmount} / ${item.lWinAmount}`
                : "",
              rRiskWin: item.rRiskAmount
                ? `${item.rRiskAmount} / ${item.rWinAmount}`
                : "",
            }))
        }
        getProcess={(data) => [consultaProcess(data), ...data]}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="lPlayer">
          Player
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="lPoints">
          Line
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="lPlacedDate"
          dataFormat={dateTimeReportFormatter}
        >
          Placed Date
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="lRiskWin">
          Risk / Win
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="rPlayer">
          Player
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="rPoints">
          Line
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="rPlacedDate"
          dataFormat={dateTimeReportFormatter}
        >
          Placed Date
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="rRiskWin">
          Risk / Win
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default ActionHistory;
